<div id="SliderBgText" class="mt-2">
  <h2 class="text-2xl font-bold mb-3">{{dataSource?.Title ? dataSource?.Title :   'دیدنی ترین مقصدهای ایران' }}</h2>
  <swiper *ngIf="sliderConfigs" [config]="sliderConfigs" (slideChange)="onSlideChange($event)" #swiper>

    <ng-template swiperSlide *ngFor="let cardData of dataSource?.Data?.Details, let i = index">
      <a [href]="cardData.Url">
        <div
          class="h-[184px] relative after:content-[''] after:absolute after:bottom-0 after:right-0 after:w-full after:h-[50px] after:bg-gradient-to-t from-black after:rounded-2xl cursor-pointer">
          <img [src]="cardData.PictureUrl" [alt]="cardData?.Name" class="rounded-2xl object-cover w-full h-full" />
          <h4 class="text-white font-bold absolute z-10 right-2 bottom-2 text-sm">
            {{cardData?.Name}}</h4>
        </div>
      </a>
    </ng-template>
  </swiper>

</div>